import React, { useState } from 'react';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import Brief from '../components/Brief';
import Counterparty from '../components/Counterparty';
import Contracts from '../components/Contracts';
import Notifications from '../components/Notifications';
import Sources from '../components/Sources';
import Settings from '../components/Settings';
import Onboarding from '../components/Onboarding';
import OneTime from '../components/OneTime';
import Analytics from '../components/Analytics';
import LawUpdates from '../components/LawUpdates';
import S1Invoices from '../components/S1Invoices';
import BankGuarantees from '../components/BankGuarantees';
import Tenders from '../components/Tenders';
import Accounting from '../components/Accounting';
import Warehouse from '../components/Warehouse';
import Production from '../components/Production';
import BankAccounts from '../components/BankAccounts';
import AIChat from '../components/AIChat';
import Feedback from '../components/Feedback';
import Tariffs from '../components/Tariffs';
import { canAccess } from '../checkPlan';

function Dashboard({ onLogout }) {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('khepri_user') || '{}');
  const [showOnboarding, setShowOnboarding] = useState(!localStorage.getItem('onboarding_done'));

  const finishOnboarding = () => {
    localStorage.setItem('onboarding_done', '1');
    setShowOnboarding(false);
  };

  if (showOnboarding) {
    return <Onboarding onDone={finishOnboarding} />;
  }

  return (
    <div>
      <header style={{ display: 'flex', justifyContent: 'space-between', padding: '16px 0', borderBottom: '1px solid #334155', marginBottom: 16 }}>
        <span style={{ fontSize: 22, fontWeight: 700 }}>Khepri</span>
        <div>
          <span style={{ marginRight: 12, color: '#94A3B8', fontSize: 14 }}>{user.name || 'Пользователь'}</span>
          <button onClick={() => { onLogout(); navigate('/login'); }} style={{ background: '#334155', color: '#F8FAFC', border: 'none', padding: '6px 12px', borderRadius: 6, cursor: 'pointer' }}>Выйти</button>
        </div>
      </header>
      <nav style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        <Link to="/" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Сегодня</Link>
        {canAccess('counterparty') && <Link to="/counterparty" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Контрагенты</Link>}
        {canAccess('contracts') && <Link to="/contracts" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Договоры</Link>}
        {canAccess('notifications') && <Link to="/notifications" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Уведомления</Link>}
        <Link to="/tenders" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Тендеры</Link>
        <Link to="/guarantees" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Гарантии</Link>
        <Link to="/s1" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>1С</Link>
        <Link to="/law-updates" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Законы</Link>
        <Link to="/one-time" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Сервисы</Link>
        <Link to="/accounting" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>📊 Налоги</Link>
        <Link to="/warehouse" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>🏭 Склад</Link>
        <Link to="/production" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>⚙️ Производство</Link>
        {canAccess('sources') && <Link to="/sources" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Источники</Link>}
        {canAccess('settings') && <Link to="/settings" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Настройки</Link>}
        <Link to="/analytics" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Аналитика</Link>
        <Link to="/bankaccounts" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>Банки</Link>
        <Link to="/aichat" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>🤖 ИИ-чат</Link>
        <Link to="/tariffs" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>💳 Тарифы</Link>
        <Link to="/feedback" style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none' }}>📮 Обратная связь</Link>
      </nav>
      <Routes>
        <Route path="/" element={<Brief />} />
        {canAccess('counterparty') && <Route path="/counterparty" element={<Counterparty />} />}
        {canAccess('contracts') && <Route path="/contracts" element={<Contracts />} />}
        {canAccess('notifications') && <Route path="/notifications" element={<Notifications />} />}
        <Route path="/tenders" element={<Tenders />} />
        <Route path="/guarantees" element={<BankGuarantees />} />
        <Route path="/s1" element={<S1Invoices />} />
        <Route path="/law-updates" element={<LawUpdates />} />
        <Route path="/one-time" element={<OneTime />} />
        <Route path="/accounting" element={<Accounting />} />
        <Route path="/warehouse" element={<Warehouse />} />
        <Route path="/production" element={<Production />} />
        {canAccess('sources') && <Route path="/sources" element={<Sources />} />}
        {canAccess('settings') && <Route path="/settings" element={<Settings />} />}
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/bankaccounts" element={<BankAccounts />} />
        <Route path="/aichat" element={<AIChat />} />
        <Route path="/tariffs" element={<Tariffs />} />
        <Route path="/feedback" element={<Feedback />} />
      </Routes>
    </div>
  );
}

export default Dashboard;